import { getCookie } from '@/utils/cookie'

// function parseDate(params) {
//   let res 
//   if(params) res  = JSON.parse(params)
//   return res
// }

export default {
  // 手机号的登录token使用cookie缓存
  loginStatus: sessionStorage.getItem('ydshPhH5Bankv3LoginStatus') || '',
  landPageRoute: sessionStorage.getItem('ydshPhH5Bankv3PageRoute') || '/', // 登录成功回调地址



  bankToken: getCookie('acquisitionBankToken'),   // 银行端token
  heavyCustomerToken: getCookie('acquisitionHeavyCustomerToken'),   // 重客token
  businessToken: getCookie('acquisitionBusinessToken'),   // 商户端token
  referenceToken: getCookie('acquisitionReferenceToken'),   // 推荐人端token
  userToken: sessionStorage.getItem('acquisitionUserToken'),   // 用户端token



}
